export { GarmentAttributes } from './GarmentAttributes'
export { PortalGarmentAttributes } from './PortalGarmentAttributes'
